import { useEffect, useRef, type RefObject } from 'react';
import { mtstatTrack } from '$/utils/mtstat';

interface ExposureItem {
  key: string;
  params: Record<string, string | number>;
}

/** 卡片真正进入可见区才曝光；同一列表生命周期内按业务身份去重。 */
export default function useTrackListExposure(root: RefObject<HTMLElement | null>, event: string, items: ExposureItem[]): void {
  const seen = useRef(new Set<string>());
  useEffect(() => {
    if (!root.current || typeof IntersectionObserver === 'undefined') return undefined;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const index = Number((entry.target as HTMLElement).dataset.exposureIndex);
        const item = items[index];
        if (!item || seen.current.has(item.key)) return;
        seen.current.add(item.key);
        mtstatTrack(event, item.params);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.01 });
    root.current.querySelectorAll('[data-exposure-index]').forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, [root, event, items]);
}
